import { render, staticRenderFns } from "./AddressViewer.vue?vue&type=template&id=f40c5348&scoped=true"
import script from "./AddressViewer.vue?vue&type=script&lang=js"
export * from "./AddressViewer.vue?vue&type=script&lang=js"
import style0 from "./AddressViewer.vue?vue&type=style&index=0&id=f40c5348&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f40c5348",
  null
  
)

export default component.exports